var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowAllCard = function SvgShowAllCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Show_All_Card_svg__a)",
    fill: "#DC9B32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0v7.228h7.228V0H.5Zm6.223 6.223H1.505V1.005h5.218v5.218ZM9.272 0v7.228H16.5V0H9.272Zm6.223 6.223h-5.218V1.005h5.218v5.218ZM.5 8.772V16h7.228V8.772H.5Zm6.223 6.223H1.505V9.777h5.218v5.218ZM9.272 8.772V16H16.5V8.772H9.272Zm6.223 6.223h-5.218V9.777h5.218v5.218Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Show_All_Card_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgShowAllCard;